import React, { Component } from "react";

class SimpleInputPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typePass: false,
    };
  }

  render() {
    const { mandatory, errorMessage, onChange, label, ...rest } = this.props;

    return (
      <div className="card-date-picker">
        <div className="margin-5px">
          <div className="txt-site txt-11 txt-main txt-bold">
            <h4>
              {label} {mandatory && <span style={{ color: "red" }}>*</span>}
            </h4>
          </div>
        </div>
        <div className="double">
          <input
            style={{ padding: 15 }}
            type={this.state.typePass ? "text" : "password"}
            className="txt txt-sekunder-color"
            required
            onChange={onChange}
            {...rest}
          />
          <button
            type="button"
            className="btn btn-grey border-left btn-no-radius"
            onClick={() => this.setState({ typePass: !this.state.typePass })}
          >
            <i
              className={
                this.state.typePass
                  ? "fa fa-lg fa-eye"
                  : "fa fa-lg fa-eye-slash"
              }
            />
          </button>
        </div>
        {mandatory && errorMessage && (
          <p className="txt-site txt-11 color-red margin-top-5px">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
}

export default SimpleInputPassword;
